import { searchClient } from '~/lib/algolia/config';

// Prevent search client from making requests with empty queries or on page load
export const customSearchClient: typeof searchClient = {
  ...searchClient,
  search(requests) {
    if (!Array.isArray(requests)) {
      return searchClient.search(requests);
    }

    const hasValidQuery = requests.some((req) => req.params?.query?.trim() !== '');

    if (!hasValidQuery) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          processingTimeMS: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
          facetHits: [],
        })),
      });
    }

    return searchClient.search(requests);
  },
};
